import React from 'react';
import Text from '../../Core/Text';

const SeerEnergyChart = ({
  title,
  subtitle,
  SavingsPctPerYr = 0,
  NewAnnualCost = 0,
  CurrentAnnualCost = 0,
  roi5yr = 0,
  roi10yr = 0,
  roi15yr = 0,
}) => {
  return (
    <div className="hvac-form-right-container">
      <Text type={'h5'} color={'black'} className={'seers-results-heading'}>
        {title}
      </Text>
      <Text type={'p'} color={'black'} className={'seers-results-sub-heading'}>
        {subtitle}
      </Text>
      <div className="savings-circle-graph-container">
        <div className="savings-item-column">
          <div className="circular-chart-container">
            <svg viewBox="0 0 36 36" className="circular-chart-bottom">
              <path
                className="circle-bottom"
                strokeDasharray="100, 100"
                d="M18 2.0845
                a 15.9155 15.9155 0 0 1 0 31.831
                a 15.9155 15.9155 0 0 1 0 -31.831"
              />
            </svg>
            <svg viewBox="0 0 36 36" className="circular-chart">
              <path
                className={`circle ${SavingsPctPerYr > 0 ? 'has-percent' : ''}`}
                strokeDasharray={`${SavingsPctPerYr}, 100`}
                d="M18 2.0845
                a 15.9155 15.9155 0 0 1 0 31.831
                a 15.9155 15.9155 0 0 1 0 -31.831"
              />
            </svg>
            <div className="savings-percent-text-container">
              <Text type="h3">{SavingsPctPerYr}%</Text>
              <Text type="p">Savings per year</Text>
            </div>
          </div>
        </div>
        <div className="savings-item-column">
          <Text type={'h6'} color={'black'}>
            Annual Energy Cost
          </Text>
          <Text type={'p'} color={'black'}>
            New cost:
            <span className="savings-result-span savings-new-cost"> ${NewAnnualCost}</span>
          </Text>
          <Text type={'p'} color={'black'}>
            Current cost:
            <span className="savings-result-span"> ${CurrentAnnualCost}</span>
          </Text>
        </div>
      </div>
      <div className="savings-bar-graph-container">
        <ul className="savings-bar-graph">
          <li>
            <span style={{ height: '20%' }} title="5-Yrs" value={'$' + roi5yr}></span>
          </li>
          <li>
            <span style={{ height: '50%' }} title="10-Yrs" value={'$' + roi10yr}></span>
          </li>
          <li>
            <span style={{ height: '75%' }} title="15-Yrs" value={'$' + roi15yr}></span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SeerEnergyChart;
